import { render } from "./Club.vue?vue&type=template&id=4188942f&scoped=true"
import script from "./Club.vue?vue&type=script&lang=js"
export * from "./Club.vue?vue&type=script&lang=js"

import "./Club.vue?vue&type=style&index=0&id=4188942f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4188942f"]])

export default __exports__